import React, { useCallback } from 'react';

import { GTMTracking } from '@common/ui/general';
import {
  AdvancedfiltersNameMapping,
  defaultAdvancedOptions,
} from '@alumni_v2/utils/constants';

import checkIcon from '@alumni_v2/images/svg/check.svg';
import selectedCheckIcon from '@alumni_v2/images/svg/selected-check.svg';

import classNames from 'classnames';

import styles from './AdvancedFiltersMobile.module.scss';

const AdvancedFiltersOptions = ({
  searchTerms,
  selectedFilters,
  selectedFilterType,
  filteredOptions,
  allFilterOptions,
  setSearchTerms,
  setSelectedFilters,
}) => {
  const isSelectedOPtionIsInDefaultOption = useCallback(() => {
    if (selectedFilters[selectedFilterType]
      && selectedFilters[selectedFilterType][0]) {
      if (defaultAdvancedOptions[selectedFilterType]
        .includes(selectedFilters[selectedFilterType][0])
        || allFilterOptions[selectedFilterType]
          .slice(0, 2).includes(selectedFilters[selectedFilterType][0])) {
        return true;
      }
    }

    return false;
  }, [allFilterOptions, selectedFilterType, selectedFilters]);

  const handleFilterChange = useCallback((filterType, value) => {
    setSelectedFilters((prevSelectedFilters) => {
      const updatedFilters = {
        ...prevSelectedFilters,
        [filterType]: prevSelectedFilters[
          filterType] && prevSelectedFilters[
          filterType][0] === value ? null : [value],
      };

      // Reset search term when a selection is made
      setSearchTerms((prevSearchTerms) => ({
        ...prevSearchTerms,
        [filterType]: '',
      }));

      return updatedFilters;
    });
  }, [setSearchTerms, setSelectedFilters]);

  const dropDownComponent = useCallback((option, index, isSelected) => (
    <GTMTracking
      className={styles.filterOptionWrapper}
      component="div"
      key={index}
      gtmEventType="cta"
      gtmEventAction="click"
      gtmEventResult="filter_section_dropdown"
      gtmEventCategory="alumni_directory"
      gtmEventData={{
        click_type: selectedFilters[
          selectedFilterType] && selectedFilters[
          selectedFilterType][0] === option
          ? 'remove_selected_filter' : 'select_filter',
        click_text: AdvancedfiltersNameMapping[selectedFilterType],
        click_section: 'filter_section_dropdown',
        gtm_custom_attributes: {
          value: option,
        },
      }}
      onClick={() => {
        handleFilterChange(selectedFilterType, option);
      }}
    >
      {
        isSelected ? (
          <img
            src={selectedCheckIcon}
            alt="check-icon"
            height={16}
            width={16}
          />
        ) : (
          <img src={checkIcon} alt="check-icon" height={16} width={16} />
        )
      }
      <div className={
        classNames(
          styles.filterOptionValue,
          { [styles.selectedDropdownOption]: isSelected },
        )
      }
      >
        {option}
      </div>
    </GTMTracking>
  ), [handleFilterChange, selectedFilterType, selectedFilters]);


  if (searchTerms[selectedFilterType]
    && searchTerms[selectedFilterType] !== ' ') {
    return (
      filteredOptions?.length > 0 ? (
        filteredOptions.map((option, index) => (
          dropDownComponent(option, index)
        ))
      ) : (
        <div className={styles.noResults}>No results found</div>
      )
    );
  } else if (((!selectedFilters[selectedFilterType]
    || selectedFilters[selectedFilterType].length === 0)
    && !searchTerms[selectedFilterType])
    || isSelectedOPtionIsInDefaultOption()) {
    return (
      <>
        <div className={styles.defaultAdvancedOptions}>
          <div className={styles.suggestedOptions}>
            {defaultAdvancedOptions[
              selectedFilterType].map((option, index) => {
              const isSelected = selectedFilters[
                selectedFilterType] && selectedFilters[
                selectedFilterType][0] === option;
              return dropDownComponent(option, index, isSelected);
            })}
          </div>

          <div className={styles.divider} />

          <div className={styles.filteredOptions}>
            {allFilterOptions[selectedFilterType]
              .slice(0, 2).map((option, index) => {
                const isSelected = selectedFilters[
                  selectedFilterType] && selectedFilters[
                  selectedFilterType][0] === option;
                return dropDownComponent(option, index, isSelected);
              })}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className={styles.defaultAdvancedOptions}>
        <div className={styles.suggestedOptions}>
          {dropDownComponent(
            selectedFilters[selectedFilterType][0], '', true,
          )}
          {defaultAdvancedOptions[selectedFilterType].map((option, index) => {
            const isSelected = selectedFilters[
              selectedFilterType] && selectedFilters[
              selectedFilterType][0] === option;
            return dropDownComponent(option, index, isSelected);
          })}
        </div>

        <div className={styles.divider} />

        <div className={styles.filteredOptions}>
          {allFilterOptions[selectedFilterType]
            .slice(0, 2).map((option, index) => {
              const isSelected = selectedFilters[
                selectedFilterType] && selectedFilters[
                selectedFilterType][0] === option?.value;
              return dropDownComponent(option, index, isSelected);
            })}
        </div>
      </div>
    );
  }
};

export default AdvancedFiltersOptions;
